import { getCountry } from 'utils/country';
import userRoles from 'constants/userRoles';
import { isReportPagePath } from 'utils/paths';
import { getOktaUserId, getUserFromToken, isTokenAvailable } from 'utils/okta';
import { getExternalUser } from 'utils/externalAccess';
import isEmpty from 'lodash/isEmpty';

export const isAdmin = (user) =>
  user?.adminInfo?.roles?.includes(userRoles.admin) &&
  user?.adminInfo?.markets?.includes(getCountry());

export const getUserRole = (user) =>
  user.isAdmin && user.adminInfo.markets.includes(getCountry()) ? userRoles.admin : userRoles.user;

export const getPdfRobotUser = (isExternalAccess) => {
  return isExternalAccess
    ? {
        name: 'pdfExternalUser',
        email: 'pdfExternalUser',
        uid: 'pdfExternalUser',
      }
    : {
        name: 'pdfInternalUser',
        email: 'pdfInternalUser',
        uid: 'pdfInternalUser',
      };
};

export const getTrackingServicesUser = (currentUser, pathname, isExternalAccess) => {
  if (isReportPagePath(pathname)) return getPdfRobotUser(isExternalAccess);

  const currentUserWithOktaId =
    !isExternalAccess && currentUser && isTokenAvailable()
      ? { ...currentUser, uid: getOktaUserId() }
      : null;
  let availableUser = isExternalAccess ? getExternalUser() : currentUserWithOktaId;
  if (isEmpty(availableUser) && isTokenAvailable()) availableUser = getUserFromToken();
  if (isEmpty(availableUser)) return null;

  return availableUser;
};
